
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { CalendarEventReminder, ReminderChannel } from "@/models/calendar-event-reminder";

const UNIT_MINUTES:{[key:string]:number} = {
	minutes: 1,
	hours: 60,
	days: 1440,
	weeks: 10080
};

export default Vue.extend({
	data() {
		return {
			amount: 30,
			unit: "minutes"
		};
	},
	props: {
		reminder: {
			type: Object as () => CalendarEventReminder,
			required: true
		}
	},
	computed: {
		channelItems(): ISelectItem<ReminderChannel>[] {
			return [ReminderChannel.APP, ReminderChannel.EMAIL, ReminderChannel.BOTH].map(c => {
				return {
					text: this.$ct("reminders.channel." + c),
					value: c
				} as ISelectItem<ReminderChannel>;
			});
		},
		unitItems(): ISelectItem<string>[] {
			return Object.keys(UNIT_MINUTES).map(u => {
				return {
					text: this.$ct("time." + u),
					value: u
				} as ISelectItem<string>;
			});
		}
	},
	methods: {
		updateMinutes() {
			let amount = Math.max(0, Math.round(this.amount || 0));
			this.amount = amount;
			this.reminder.MinutesBefore = amount * (UNIT_MINUTES[this.unit] || 1);
		},
		splitMinutes() {
			let minutes = this.reminder.MinutesBefore;
			let unit = "minutes";
			for (let u of ["weeks", "days", "hours"]) {
				if (minutes > 0 && minutes % UNIT_MINUTES[u] == 0) {
					unit = u;
					break;
				}
			}
			this.unit = unit;
			this.amount = minutes / UNIT_MINUTES[unit];
		}
	},
	mounted() {
		this.splitMinutes();
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
